import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { ZeitPage } from "./pages/ZeitPage";
import { TextDesignerPage } from "./pages/TextDesignerPage";
import { MusicStudioPage } from "./pages/MusicStudio/MusicStudioPage";
import "./index.css"; // Keep global styles

function App() {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;

  // Redirect old worldstream path to new domain
  if (pathname === "/worldstream") {
    window.location.href = "https://worldstream.io";
    return null;
  }

  // Define components based on hostname
  let MainComponent;
  if (hostname === "zeit.mokachika.com") {
    MainComponent = ZeitPage;
  } else {
    MainComponent = HomePage;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainComponent />} />
        <Route path="/text" element={<TextDesignerPage />} />
        <Route path="/music" element={<MusicStudioPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
